import styles from './PrimaryCta.module.css';

export const PRIMARY_CTA_LABEL = 'Meet your teammate';

type PrimaryCtaProps = {
	onClick: () => void;
	label?: string;
	className?: string;
	variant?: 'dark' | 'light';
};

export const PrimaryCta = ({
	onClick,
	label,
	className,
	variant = 'dark',
}: PrimaryCtaProps) => {
	const variantClass = variant === 'light' ? styles.light : styles.dark;
	const classes = [styles.btn, variantClass, className]
		.filter(Boolean)
		.join(' ');
	return (
		<button type="button" className={classes} onClick={onClick}>
			<span>{label ?? PRIMARY_CTA_LABEL}</span>
			<svg
				className={styles.arrow}
				viewBox="0 0 20 20"
				width="20"
				height="20"
				aria-hidden="true"
				focusable="false"
			>
				<path
					d="M4 10h11M11 6l4 4-4 4"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.75"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</button>
	);
};
